import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/';
import { messages } from './messages';

export const Carrier = {
  id: 'carrier',
  displayName: <FormattedMessage {...messages.carrier} />,
  type: OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER_OR_BLANK,
  filterValue: 'carrierId',
  expectsArgumentAsArray: true,
  allowsMultipleSelection: true,

  render: (criteriaInformations, existingFiltersHelpers) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER_OR_BLANK, criteriaInformations, existingFiltersHelpers);
  },
};
